import script from "./AboutSauter.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSauter.vue?vue&type=script&setup=true&lang=js"

import "./AboutSauter.vue?vue&type=style&index=0&id=4dd9a9b6&lang=css"

const __exports__ = script;

export default __exports__